import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import PropTypes from "prop-types";
import { TabPanelImpl } from "./tab-panel.styles.es.js";
import { tabsContext } from "./tabs-context.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  tabKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
const TabPanel = ({ children, tabKey }) => {
  const [activeKey] = useContext(tabsContext);
  return /* @__PURE__ */ jsx(
    TabPanelImpl,
    {
      "aria-labelledby": `tab--${tabKey}`,
      hidden: tabKey !== activeKey,
      children
    }
  );
};
TabPanel.propTypes = propTypes;
export {
  TabPanel
};
